import { memo, useEffect } from 'react';
import Box from '../Box/Box';
import Text from '../Text/Text';
import React from 'react';
import { Pressable } from 'react-native';
import {
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { DARK_VARIANT, LIGHT_VARIANT, SIZES } from './Switch.content';

function Switch({
  value,
  onValue,
  size = 'small',
  locNS,
  locKey,
  light = false,
}: {
  value: boolean;
  onValue: (value: boolean) => void;
  size?: 'big' | 'small';
  locNS?: string;
  locKey?: string;
  light?: boolean;
}) {
  const {
    trackHeight,
    trackWidth,
    thumbSize,
    translateX: thumbTranslateX,
  } = SIZES[size];

  const colorConfig = light ? LIGHT_VARIANT : DARK_VARIANT;

  const progress = useSharedValue(value ? 1 : 0);
  const translateX = useSharedValue(value ? thumbTranslateX : 0);

  useEffect(() => {
    progress.value = withTiming(value ? 1 : 0, { duration: 200 });
    translateX.value = withTiming(value ? thumbTranslateX : 0, {
      duration: 200,
    });
  }, [value, progress, translateX, thumbTranslateX]);

  const onClick = () => {
    onValue(!value);
  };

  const animatedStyle = {
    container: useAnimatedStyle(() => {
      const backgroundColor = interpolateColor(
        progress.value,
        [0, 1],
        [colorConfig.container.colorOff, colorConfig.container.colorOn],
      );
      return { backgroundColor };
    }),
    child: useAnimatedStyle(() => {
      const backgroundColor = interpolateColor(
        progress.value,
        [0, 1],
        [colorConfig.child.colorOff, colorConfig.child.colorOn],
      );
      return {
        backgroundColor,
        transform: [{ translateX: translateX.value }],
      };
    }),
  };

  return (
    <Box flexDirection="row" gap="space-200" alignItems="center">
      <Pressable onPress={onClick}>
        <Box
          height={trackHeight}
          width={trackWidth}
          padding="space-050"
          borderRadius="radius-full"
          justifyContent="center"
          animatedStyle={animatedStyle.container}
        >
          <Box
            height={thumbSize}
            width={thumbSize}
            animatedStyle={animatedStyle.child}
            borderRadius="radius-full"
          ></Box>
        </Box>
      </Pressable>

      {locNS && locKey ? (
        <Box>
          <Text
            variant="button-small"
            color={colorConfig.text.color}
            locNS="common"
            locKey="confirm"
          />
          <Text
            variant="caption"
            color={colorConfig.text.subColor}
            locNS="common"
            locKey="learnMore"
          />
        </Box>
      ) : null}
    </Box>
  );
}

export default memo(Switch);
